var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuItemArrowRightXxl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.402 11.43l5.261-5.2a.555.555 0 000-.793L1.402.237a.829.829 0 00-1.162 0 .806.806 0 000 1.148l4.501 4.449-4.5 4.447a.806.806 0 000 1.148.829.829 0 001.16 0z",
    fill: "#70777E"
  })));
}

export default SvgIconMenuItemArrowRightXxl;